import React from "react";
import styled from "styled-components";
import { DraftDecoratorComponentProps } from "@sonder/editor/typings/editor";
import { colors } from "@sonder/ui/source/styled/theme";

export const StyledMention = styled.span`
  color: ${colors.blue7};
`;

export interface MentionProps extends DraftDecoratorComponentProps {}
export const Mention = ({ children, entityKey }: MentionProps) => {
  return (
    <StyledMention data-user-id={entityKey} title={entityKey}>
      {children}
    </StyledMention>
  );
};
